class WizardTitle {
    constructor($scope, StateUtils, $state) {
        this.$onInit = () => {
            const model = StateUtils.activeDataForState(true).model;
            $scope.productName = model.baseData.productName.value;
            $scope.accountNumber = model.baseData.accountNumber.value;

            $scope.isQuote = this.isQuote;
            $scope.isPolicyChange = this.isPolicyChange;
            $scope.isRenewal = this.isRenewal;

            const quoteDisplayKeyMap = {
                PersonalAuto: 'portal.components.transactionWizardTitle.transactionWizardTitle.PersonalAuto Quote With QuoteID',
                BusinessOwners: 'portal.components.transactionWizardTitle.transactionWizardTitle.BusinessOwners Quote With QuoteID',
                Homeowners: 'portal.components.transactionWizardTitle.transactionWizardTitle.HomeOwners Quote With QuoteID',
                CommercialProperty: 'portal.components.transactionWizardTitle.transactionWizardTitle.Commercial Property Quote With QuoteID',
                WC7WorkersComp: 'portal.components.transactionWizardTitle.transactionWizardTitle.Workers Compensation Quote With QuoteID'
            };
            const defaultquoteDisplayKey = 'portal.components.transactionWizardTitle.transactionWizardTitle.Quote With QuoteID';

            const productCode = model.baseData.productCode.value;
            $scope.quoteDisplayKey = quoteDisplayKeyMap[productCode] || defaultquoteDisplayKey;

            if ($scope.isRenewal) {
                $scope.transactionID = model.jobID.value;
                $scope.accountHolder = model.baseData.accountHolder.displayName.value;
                $scope.policyNumber = model.policyNumber.value;
            } else if ($scope.isPolicyChange) {
                $scope.transactionID = model.jobID.value;
                $scope.accountHolder = model.baseData.accountName.value;
                $scope.policyNumber = model.policyNumber.value;
            } else if ($scope.isQuote) {
                $scope.isQuotePortal = model.sessionUUID.value === undefined;
                $scope.quoteID = model.quoteID.value;
                $scope.accountHolder = model.baseData.accountHolder.value;

                $scope.$watch(() => $state.current.name, currentState => {
                    $scope.currentState = currentState;

                    const isAddBuildingWizard = currentState.includes('cpBuildingWizard')
                        && !['cpBuildingWizardBuildingsList', 'cpBuildingWizardInitialScreen', 'cpBuildingWizardSpreadsheetScreen'].includes(currentState);
                    $scope.isSideScreen = ['bopLocation', 'bopBuilding'].includes(currentState) || isAddBuildingWizard;

                    $scope.isBOPBuildingEditing = Boolean($state.params.building);
                });
            }
        };
    }
}

WizardTitle.$inject = ['$scope', 'StateUtils', '$state'];

export default WizardTitle;
